import React from 'react'
import { Box } from '@mui/material'
import { PCells } from '../../../types/carbon/models/PCells'
import { SettingsSwitch, SettingsTextField, SettingsRow } from './SettingsControls'

interface CellsSectionProps {
  cells: PCells
  onChange: (cells: PCells) => void
}

export const PrimaryCellsSection: React.FC<CellsSectionProps> = ({ cells, onChange }) => {
  const update = (patch: Partial<PCells>) => onChange({ ...cells, ...patch })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <SettingsRow>
        <SettingsSwitch label="Frequencies" checked={cells.frequencies} onChange={v => update({ frequencies: v })} />
        <SettingsSwitch label="Column %" checked={cells.columnPercents} onChange={v => update({ columnPercents: v })} />
        <SettingsSwitch label="Row %" checked={cells.rowPercents} onChange={v => update({ rowPercents: v })} />
      </SettingsRow>
    </Box>
  )
}

export const AdvancedCellsSection: React.FC<CellsSectionProps> = ({ cells, onChange }) => {
  const update = (patch: Partial<PCells>) => onChange({ ...cells, ...patch })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <SettingsRow>
        <SettingsSwitch label="% Sign" checked={cells.percentSign} onChange={v => update({ percentSign: v })} />
        <SettingsSwitch label="% as Proportions" checked={cells.percentsAsProportions} onChange={v => update({ percentsAsProportions: v })} />
        <SettingsSwitch label="1000s Separator" checked={cells.thousandsSeparator} onChange={v => update({ thousandsSeparator: v })} />
      </SettingsRow>
      <SettingsRow>
        <SettingsSwitch label="Missing as Zero" checked={cells.missingAsZero} onChange={v => update({ missingAsZero: v })} />
        <SettingsSwitch label="Missing as Blank" checked={cells.missingAsBlank} onChange={v => update({ missingAsBlank: v })} />
        <SettingsSwitch label="Zero as Blank" checked={cells.zeroAsBlank} onChange={v => update({ zeroAsBlank: v })} />
      </SettingsRow>
      <SettingsRow>
        <SettingsSwitch label="Blank as Char" checked={cells.blankAsChar} onChange={v => update({ blankAsChar: v })} />
        {cells.blankAsChar && (
          <SettingsTextField label="Blank Char" value={cells.blankChar || ''} onChange={v => update({ blankChar: v })} fullWidth={false} />
        )}
      </SettingsRow>
      <SettingsSwitch label="Show Redundant 100%" checked={cells.showRedundant100} onChange={v => update({ showRedundant100: v })} />
    </Box>
  )
}

const CellsSection: React.FC<CellsSectionProps> = ({ cells, onChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <PrimaryCellsSection cells={cells} onChange={onChange} />
      <AdvancedCellsSection cells={cells} onChange={onChange} />
    </Box>
  )
}

export default CellsSection
